<template>
  <div
    v-show="loading"
    class="d-flex align-items-center justify-content-center onb-beat-loader">
    <div
      class="onb-beat onb-beat-odd"
      :style="spinnerStyle" />
    <div
      class="onb-beat onb-beat-even"
      :style="spinnerStyle" />
    <div
      class="onb-beat onb-beat-odd"
      :style="spinnerStyle" />
  </div>
</template>

<script setup lang="ts">
  const props = defineProps({
    color: {
      default: "#035953",
      type: String,
    },
    loading: {
      default: true,
      type: Boolean,
    },
    margin: {
      default: "2px",
      type: String,
    },
    radius: {
      default: "100%",
      type: String,
    },
    size: {
      default: "12px",
      type: String,
    },
  });
  const spinnerStyle = {
    backgroundColor: props.color,
    borderRadius: props.radius,
    height: props.size,
    margin: props.margin,
    width: props.size,
  };
</script>

<style lang="scss">
.onb-beat-loader {
  .onb-beat {
    -webkit-animation: fcBeatDelay 0.7s infinite linear;
    animation: fcBeatDelay 0.7s infinite linear;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    display: inline-block;
  }

  .onb-beat-odd {
    animation-delay: 0s;
  }

  .onb-beat-even {
    animation-delay: 0.35s;
  }
}

@keyframes fcBeatDelay {
  50% {
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
    -webkit-opacity: 0.2;
    opacity: 0.2;
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-opacity: 1;
    opacity: 1;
  }
}
</style>
